(() => {
    const header = document.querySelector('.site-header');
    if (!header) return;
    function measureHeader() {
        document.documentElement.style.setProperty('--site-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    }
    measureHeader();
    if ('ResizeObserver' in window) new ResizeObserver(measureHeader).observe(header);
    window.addEventListener('resize', measureHeader, { passive: true });
})();
